import { FC } from 'react';
import { useResponsive } from 'v3/common/hooks/useResponsive';
import { getData } from '../configs';
import Lottie from 'lottie-react';
import _ from 'lodash';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const locale = ApplicationDomainUtility.locale;
const roboArm = getData(locale, 'roboArm');

type RoboarmProps = {
  productName: string;
};

const Roboarm: FC<RoboarmProps> = ({ productName }) => {
  const isMobile = useResponsive();
  return (
    <div className="row strategy-tools__card ">
      <div className="card card-red">
        <h3>Automate Your Execution</h3>
        <p>
          {_.capitalize(ApplicationDomainUtility.partnerName) || productName} lets you automate your trading from signal to
          execution, ensuring you never miss a trade. Deploy strategies effortlessly and eliminate manual
          execution during live market sessions.
        </p>

        <ul>
          <li>Enable hands-free trading execution</li>
          <li>Automate live trades with confidence</li>
          <li>Stay active in the markets 24/7</li>
        </ul>
        {!isMobile && <Lottie animationData={roboArm} loop className="roboarm-lottie" />}
      </div>
    </div>
  );
};

export default Roboarm;
